import { render } from "./Contacter.vue?vue&type=template&id=a98356a6&scoped=true&lang=pug"
import script from "./Contacter.vue?vue&type=script&lang=ts"
export * from "./Contacter.vue?vue&type=script&lang=ts"

import "./Contacter.vue?vue&type=style&index=0&id=a98356a6&scoped=true&lang=sass"
import "./Contacter.vue?vue&type=style&index=1&id=a98356a6&lang=sass"
script.render = render
script.__scopeId = "data-v-a98356a6"

export default script